export const STORY_WORD_TAP_RECOGNITION_MESSAGES = {
  CORRECT: (word: string) => `<correctly tapped ${word}>`,
  INCORRECT: (word: string) => `<incorrectly tapped ${word}>`,
  NO_RESPONSE: `<no response recognized>`,
} as const;
